exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.botonSeriado {\r\n  display: none !important;\n}\r\n", ""]);

// exports
